var React = require('react');

function DocumentPencil48px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M45.598 40.534l-2.792 6.778a.995.995 0 0 1-1.84.001l-2.887-7.005a.84.84 0 0 1-.022-.053l-.076-.185a.992.992 0 0 1 .019-.793V10.402a.989.989 0 0 1-.095-.413c0-.149.037-.286.095-.413V4.413a.98.98 0 0 1-.095-.412A3.992 3.992 0 0 1 41.886.007c2.025 0 3.683 1.532 3.929 3.5a.607.607 0 0 1 .185.431v36c0 .292-.167.48-.402.596zM44 4.46a.97.97 0 0 1-.126-.459 1.996 1.996 0 0 0-1.988-1.998c-1.097 0-1.99.897-1.99 1.998 0 .03-.015.055-.017.085.002.029.017.054.017.084v4.82H44V4.46zm0 6.527h-4.104v28.502l1.99 4.828 2.063-5.01c.012-.03.036-.048.051-.076V10.987zm-10.074 6.08v27.867a2.994 2.994 0 0 1-2.985 2.995H2.975a2.994 2.994 0 0 1-2.986-2.995V2.999A2.994 2.994 0 0 1 2.975.004h14.031c.023 0 .043.012.066.013a.965.965 0 0 1 .254.052c.034.012.067.02.1.036A.98.98 0 0 1 17.7.29l.011.009 15.813 15.864c.031.021.046.058.073.083.034.031.06.066.089.102.149.174.258.382.258.629 0 .032-.015.059-.018.09zM1.98 2.999v41.935a1 1 0 0 0 .995.999h27.966c.548 0 1.059-.444 1.059-.995v-27H17c-.55 0-.99-.409-.99-.961V1.939H3c-.549 0-1.02.51-1.02 1.06zm16.021.414v12.566h12.526L18.001 3.413z","key":1})]);
}

DocumentPencil48px.displayName = "DocumentPencil48px";

DocumentPencil48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 46 47.94"};

module.exports = DocumentPencil48px;

DocumentPencil48px.default = DocumentPencil48px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/document-pencil-48px.svg
// module id = 1136
// module chunks = 0